import axiosLib from 'axios';
import { useAuthStore } from '@/stores/auth';
import { LocalStorageKeys } from '@/utils/constants';

const axios = axiosLib.create();

axios.interceptors.request.use(
  (config) => {
    const { serverIp, port, protocol, addRequest } = useAuthStore();

    const sessionID = localStorage.getItem(LocalStorageKeys.SessionID);

    config.baseURL = protocol + serverIp + ':' + port;
    config.headers['is-sessionid'] = sessionID;
    addRequest();
    return config;
  },
  (error) => {
    const { removeRequest } = useAuthStore();
    removeRequest();
    console.log(error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (value) => {
    const authStore = useAuthStore();
    authStore.removeRequest();
    return value;
  },
  async (error) => {
    const authStore = useAuthStore();
    authStore.removeRequest();
    if (error.response) {
      const { status, data } = error.response;
      if (status === 400 && data === 'SessionID is invalid') {
        await authStore.logout(true);
        return;
      }
    }
    alert(`Error: ${error.message}`);
    return Promise.reject({ ...error, data: { success: false, message: error.message } });
  }
);

export { axios };
